export default {
    COMPANY: 1,
    CONTACT: 2,
    CONTACTCARDNOTIFICATION: 3,
    ONBOARDFORMNOTIFICATION: 4
};
